<template lang="html">
  <ProductSelectionBase v-model="modelProxy" type="fertilizer" v-bind="{entityLookup, filter, filters, showArchived, products, recommendedIds, previouslyUsedProducts}">
    <template #sidebar="{hasRecommendations}">
      <ProductFiltersFertilizer v-model="filters" v-bind="{hasRecommendations}" />
    </template>

    <template #tile="scope">
      <ProductTileFertilizer v-bind="scope" />
    </template>
  </ProductSelectionBase>
</template>

<script>
import {modelProxy} from '@helpers/vuex'

import ProductSelectionBase from './ProductSelectionBase'
import ProductFiltersFertilizer from './ProductFiltersFertilizer'
import ProductTileFertilizer from './ProductTileFertilizer'

export default {
  components: {
    ProductSelectionBase,
    ProductFiltersFertilizer,
    ProductTileFertilizer
  },
  props: {
    value: String, // productId
    filter: Function,
    showArchived: Boolean,
    entityLookup: {
      type: Object,
      required: true
    },
    products: {
      type: Object,
      required: true
    }, // {[productId]: product, ...more}
    previouslyUsedProducts: {
      type: Array,
      default: () => []
    },
    recommendedIds: {
      type: Array,
      default: () => []
    } // [productId, ...more]
  },
  data () {
    return {
      filters: {
        showRecommendations: true,
        onlyPreviouslyUsed: false,
        search: '',
        nutrients: []
      }
    }
  },
  computed: {
    modelProxy
  }
}
</script>

<style lang="scss" module>
</style>
